import { type FC, useEffect } from 'react';

import { useCommonModal } from 'renderer/components/CommonModal';
import { useCookieConsent } from 'renderer/components/CookieConsent/context';

import { CookieConsentModalData } from './CookieConsentModalData';

export const CookieConsentModal: FC = () => {
  const { openModal: openCookieConsentModal } = useCommonModal();
  const { hasConsentCookie } = useCookieConsent();

  useEffect(() => {
    if (!hasConsentCookie) {
      openCookieConsentModal(CookieConsentModalData({}));
    }
  }, [hasConsentCookie, openCookieConsentModal]);

  return null;
};
